<template>
  <div class="wl-container">

    <div :class="tableStatus.editable ? 'table-operator' : ''">
      <el-table :data="data"
                ref="table"
                height="100%"
                v-loading="loading"
                border
                stripe
                @selection-change="handleSelectionChange"
                class="wl-table">

        <el-table-column type="selection"
                         width="50"></el-table-column>
        <el-table-column prop="groupName"
                         width="180"
                         :label="$t('PAGE_PBCLIST_NAME')">
        </el-table-column>
        <el-table-column prop="periodEndDate"
                         width="160"
                         :label="$t('TABLE_HEADER_periodEndDate')">
          <template slot-scope="scope">
            {{scope.row.periodEndDate|formatDate}}
          </template>
        </el-table-column>
        <el-table-column prop="detailedInfoReq"
                         :label="$t('TABLE_HEADER_detailedInfoReq')"></el-table-column>
        <el-table-column width="140"
                         :label="$t('TABLE_HEADER_DETAILS')">
          <template slot-scope="scope">
            <el-button @click="details(scope.row)" type="text">{{$t('COMMON_VIEW')}}</el-button>
          </template>
        </el-table-column>

      </el-table>
    </div>

    <div v-if='tableStatus.editable'
         class="wl-btn-container">

      <el-button class="cancel-btn"
                 @click="onCancelBeh">{{$t('comment_reSet')}}
      </el-button>

      <!-- 下载按钮 -->
      <el-button :disabled="emptyChosen"
                 class="wl-green"
                 @click="copy">{{$t('COMMON_COPY')}}
      </el-button>

    </div>
  </div>

</template>
<script>
    import {dateFormat} from '@/utils'

    export default {
        data() {
            return {
                chosenList: []
            };
        },
        filters: {
            formatDate: value => {
                if (value != null) {
                    return dateFormat(new Date(value), 'yyyy-MM-dd')
                } else {
                    return value
                }
            }
        },
        methods: {
            handleSelectionChange(v) {
                this.chosenList = v;
            },
            copy() {
                this.onCopy(_.map(this.chosenList, v => v.id));
            },
            details(row) {
                this.$router.push({path: '/new-pbc-list', query: {audit: '1', id: row.id, edit: 'N'}});
            },
            onCancelBeh() {
                this.$refs.table.clearSelection()
                this.onCancel()
            }
        },
        mounted() {
            
        },
        computed: {
            emptyChosen() {
                return _.isEmpty(this.chosenList);
            }
        },
        props: {
            data: Array,
            tableStatus: {
                type: Object,
                required: true
            },
            onCancel: {
                type: Function,
                default: () => {
                }
            },
            onCopy: {
                type: Function,
                default: () => {
                }
            },
            loading: Boolean
        }
    };
</script>
<style scoped>
  .wl-container {
    height: 100%;
  }

  .table-operator{
    height: calc(100% - 48px);
  }
  .wl-table {
    margin-bottom: 6px;
  }

  .wl-btn-container {
    height: 48px;
    padding: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
</style>
